export function initCallMethod (bridge) {
  bridge.call = function (FnName, params, callback) {
    if (typeof FnName !== 'string') {
      console.error('bridge.call FnName必须使用string类型， 传入FnName: ', FnName)
      return
    }
    if (FnName in bridge) {
      bridge[FnName](params, callback)
    } else {
      console.error(`bridge.call 不存在"${FnName}"方法`)
    }
  }
}
